// @flow
import ContentConfigurationElements from "./ContentConfigurationElements";
import LayoutHintCollection from "../layouthint/LayoutHintCollection";
import { isPlainObject } from "../../utils";

/**
 */
class ContentConfigurationResults {
  _configuration: Object;
  _layouthint: LayoutHintCollection;

  /**
   */
  constructor(configuration: Object) {
    this._configuration = configuration || null;

    this._layouthint = new LayoutHintCollection(configuration?.layouthint);
  }

  /**
   */
  get label(): string | null {
    if (this._configuration === null) {
      return null;
    }

    return this._configuration.label;
  }

  /**
   */
  get description(): string | null {
    if (this._configuration === null) {
      return null;
    }

    const description = this._configuration.description;
    if (isPlainObject(description) && "message" in description) {
      return description.message;
    }

    return description;
  }

  /**
   */
  get attributes(): Array<string> {
    if (this._configuration === null) {
      return [];
    }

    // An issue with mapped attributes is giving us the wrong attribute keys in the attributes property
    // as a temporary fix a layouthint with the correct mapped attribute key can be set in the configuration of the end results
    return [
      ...this._configuration.attributes,
      ...this.layouthint.all
        .filter((hint) => hint.includes("attribute:"))
        .map((hint) => hint.substring("attribute:".length)),
    ];
  }

  /**
   */
  getFormConfigElement(elementKey: string): ContentConfigurationElements {
    if (this._configuration === null) {
      return new ContentConfigurationElements([]);
    }

    const configElement = this._configuration[elementKey];

    return new ContentConfigurationElements(configElement);
  }

  /**
   */
  get calculatedResultElements(): ContentConfigurationElements {
    return this.getFormConfigElement("calculatedResultElements");
  }

  /**
   */
  get positiveResultElements(): ContentConfigurationElements {
    return this.getFormConfigElement("positiveResultElements");
  }

  /**
   */
  get negativeResultElements(): ContentConfigurationElements {
    return this.getFormConfigElement("negativeResultElements");
  }

  /**
   */
  get resultElements(): ContentConfigurationElements {
    return this.getFormConfigElement("resultElements");
  }

  /**
   */
  get layouthint(): LayoutHintCollection {
    return this._layouthint;
  }
}

export default ContentConfigurationResults;
